<div class="panel mt-5">
  <div class="flex justify-between">
    <h1 class="mb-5 text-lg font-bold">
      {{ "edit_config" | translate }}
    </h1>
    <div class="mb-6 flex" *appHasRole="[userRole.SuperAdmin]">
      <button type="button" class="btn btn-warning mr-2 rounded-full" (click)="applyChanges()" *ngIf="config && !config.isApplied && !isEditMode">
        {{ "apply_config" | translate }}
      </button>
      <a (click)="changeMode()" *ngIf="!isEditMode" class="btn btn-primary cursor-pointer rounded-full p-2 ltr:ml-auto rtl:mr-auto">
        <icon-pencil-paper />
      </a>
    </div>
  </div>
  <section>
    <form [formGroup]="configForm" (submit)="onSaveConfig()">
      <div class="grid grid-cols-2 gap-5">
        <div class="mb-5" [ngClass]="configForm.controls['allowedOrigins'].touched ? (configForm.controls['allowedOrigins'].errors ? 'has-error' : 'has-success') : ''">
          <label for="allowedOrigins">{{ "allowed_origins" | translate }}</label>
          <input id="allowedOrigins" type="text" class="form-input" placeholder="{{ 'allowed_origins_placeholder' | translate }}" formControlName="allowedOrigins" [readonly]="!isEditMode" />
          <small class="text-danger" *ngIf="configForm.controls['allowedOrigins'].errors && configForm.controls['allowedOrigins'].touched">
            {{ "please_provide_value" | translate }}
          </small>
        </div>

        <div class="mb-5" [ngClass]="configForm.controls['instanceApiConnectionString'].touched ? (configForm.controls['instanceApiConnectionString'].errors ? 'has-error' : 'has-success') : ''">
          <label for="instanceApiConnectionString">{{ "instance_api_connection_string" | translate }}</label>
          <input
            id="instanceApiConnectionString"
            type="text"
            class="form-input"
            placeholder="{{ 'instance_api_connection_string_placeholder' | translate }}"
            formControlName="instanceApiConnectionString"
            [readonly]="!isEditMode"
          />
          <small class="text-danger" *ngIf="configForm.controls['instanceApiConnectionString'].errors && configForm.controls['instanceApiConnectionString'].touched">
            {{ "please_provide_value" | translate }}
          </small>
        </div>

        <div class="mb-5" [ngClass]="configForm.controls['authBaseUrl'].touched ? (configForm.controls['authBaseUrl'].errors ? 'has-error' : 'has-success') : ''">
          <label for="authBaseUrl">{{ "auth_base_url" | translate }}</label>
          <input id="authBaseUrl" type="text" class="form-input" placeholder="{{ 'auth_base_url_placeholder' | translate }}" formControlName="authBaseUrl" [readonly]="!isEditMode" />
          <small class="text-danger" *ngIf="configForm.controls['authBaseUrl'].errors && configForm.controls['authBaseUrl'].touched">
            {{ "please_provide_value" | translate }}
          </small>
        </div>

        <div class="mb-5" [ngClass]="configForm.controls['authSecret'].touched ? (configForm.controls['authSecret'].errors ? 'has-error' : 'has-success') : ''">
          <label for="authSecret">{{ "auth_secret" | translate }}</label>
          <input id="authSecret" type="text" class="form-input" placeholder="{{ 'auth_secret_placeholder' | translate }}" formControlName="authSecret" [readonly]="!isEditMode" />
          <small class="text-danger" *ngIf="configForm.controls['authSecret'].errors && configForm.controls['authSecret'].touched">
            {{ "please_provide_value" | translate }}
          </small>
        </div>

        <div class="mb-5" [ngClass]="configForm.controls['authApiKey'].touched ? (configForm.controls['authApiKey'].errors ? 'has-error' : 'has-success') : ''">
          <label for="authApiKey">{{ "auth_api_key" | translate }}</label>
          <input id="authApiKey" type="text" class="form-input" placeholder="{{ 'auth_api_key_placeholder' | translate }}" formControlName="authApiKey" [readonly]="!isEditMode" />
          <small class="text-danger" *ngIf="configForm.controls['authApiKey'].errors && configForm.controls['authApiKey'].touched">
            {{ "please_provide_value" | translate }}
          </small>
        </div>

        <div class="mb-5" [ngClass]="configForm.controls['eTouristBaseUrl'].touched ? (configForm.controls['eTouristBaseUrl'].errors ? 'has-error' : 'has-success') : ''">
          <label for="eTouristBaseUrl">{{ "etourist_base_url" | translate }}</label>
          <input id="eTouristBaseUrl" type="text" placeholder="{{ 'etourist_base_url_placeholder' | translate }}" class="form-input" formControlName="eTouristBaseUrl" [readonly]="!isEditMode" />
          <small class="text-danger" *ngIf="configForm.controls['eTouristBaseUrl'].errors && configForm.controls['eTouristBaseUrl'].touched">
            {{ "please_provide_value" | translate }}
          </small>
        </div>

        <div class="mb-5" [ngClass]="configForm.controls['adminName'].touched ? (configForm.controls['adminName'].errors ? 'has-error' : 'has-success') : ''">
          <label for="adminName">{{ "admin_name" | translate }}</label>
          <input id="adminName" type="text" placeholder="{{ 'admin_name' | translate }}" class="form-input" formControlName="adminName" [readonly]="!isEditMode" />
          <small class="text-danger" *ngIf="configForm.controls['adminName'].errors && configForm.controls['adminName'].touched">
            {{ "please_provide_value" | translate }}
          </small>
        </div>

        <div class="mb-5" [ngClass]="configForm.controls['adminSurname'].touched ? (configForm.controls['adminSurname'].errors ? 'has-error' : 'has-success') : ''">
          <label for="adminSurname">{{ "admin_surname" | translate }}</label>
          <input id="adminSurname" type="text" placeholder="{{ 'admin_surname' | translate }}" class="form-input" formControlName="adminSurname" [readonly]="!isEditMode" />
          <small class="text-danger" *ngIf="configForm.controls['adminSurname'].errors && configForm.controls['adminSurname'].touched">
            {{ "please_provide_value" | translate }}
          </small>
        </div>
      </div>

      <div class="mt-8 flex items-center justify-end">
        <a *ngIf="isEditMode" (click)="cancelEditMode()" class="btn btn-danger w-52 cursor-pointer ltr:ml-4 rtl:mr-4">
          {{ "cancel" | translate }}
        </a>

        <button *ngIf="!isLoading && isEditMode" type="submit" (click)="onSaveConfig()" class="btn btn-primary w-52 ltr:ml-4 rtl:mr-4">
          {{ "save" | translate }}
        </button>

        <button *ngIf="isLoading" type="button" class="btn btn-primary ltr:ml-4 rtl:mr-4">
          <span class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-l-transparent align-middle ltr:mr-4 rtl:ml-4"></span>
          {{ "loading" | translate }}
        </button>
      </div>
    </form>
  </section>
</div>
